import VerifyEmailError from './VerifyEmailError';
class InvestorNotRegisted extends VerifyEmailError {
    constructor(options) {
        super('Investor who requested the token is not registered', options);
    }
}
export default InvestorNotRegisted;
